<template>
  <div class="card" :style="cssVariables" v-bind:class="{ 'card--horizontal': horizontal }">
    <div class="card__media" v-if="$slots.media">
      <slot name="media" />
    </div>
    <div class="card__content">
      <div class="card__header">
        <slot name="header" />
      </div>
      <div class="card__body">
        <slot name="body" />
      </div>
      <div class="card__actions" v-if="$slots.actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'card',

  props: {
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {}
  },

  computed: {

    cssVariables () {
      return {
        '--card-color': this.cardColor,
        '--text-color': this.textColor,
        '--accent-color': this.accentColor,
        '--border-color': this.borderColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  width: 100%;
  flex-direction: column;
  background: var(--card-color);
  box-shadow: 0 0.1875rem 0.375rem rgba(0, 0, 0, 0.4);
  border-radius: 0.375rem;
  overflow: hidden;
  color: var(--text-color);
  border: 0;
  transform: translateY(0) translateZ(0) scale(1.0, 1.0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;

  &.active {
    background-color: var(--accent-color);
  }

  &:hover {
    transform: translateY(-0.1875rem);
    box-shadow: 0 0.625rem 1.5rem rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &__media {
    width: 100%;
    max-height: 200px;
    overflow: hidden;
    display: flex;

    img {
      display: block;
      width: 100%;
      max-height: 100%;
      object-fit: cover;
      transition: opacity 0.3s ease;
    }
  }

  &__content {
    width: 100%;
    padding: 1.625rem;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &__header {
    line-height: 1.625rem;
    overflow: hidden;
    font-size: 1.3rem;
    font-weight: 700;
    letter-spacing: normal;
    transition: color .4s;
    margin-bottom: 0.5rem;
    text-transform: none;
    word-break: break-word;
  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    font-size: 1.1rem;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 1.3rem;
    margin-bottom: 1.5rem;
    flex: 1;
    word-break: break-word;
  }

  &__actions {
    font-size: 0.875rem;
    line-height: 1;
    margin: 1.125rem 0 0 0;
    padding: 1.125rem 0 0 0;
    border-top: 1px solid var(--border-color);
    display: flex;
  }

  &--horizontal {
    flex-direction: row;

    .card__media {
      position: relative;
      max-height: none;
      min-height: 100%;
      width: calc(100% / 3 * 1);

      img {
        position: absolute;
        top: 0;
        left: 0;
        min-height: 100%;
      }
    }

    &__content {
      width: calc(100% / 3 * 2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue